import { AutocompleteInput, AutocompleteInputProps, ReferenceInput } from 'react-admin';

import { GetB2bCompaniesOneResponse, GetB2bCompaniesQuery } from '@Common/types/bo/b2b/companies';

type B2bCompanySelectInputProps = Omit<
  AutocompleteInputProps<GetB2bCompaniesOneResponse>,
  'filter'
> & {
  source: string;
  reference?: 'b2b/companies' | 'companies';
  referenceFilter?: GetB2bCompaniesQuery['filter'];
  optionText?: (record: GetB2bCompaniesOneResponse) => string;
  testId?: string;
};

const idOrFieldFilterToQuery = (fieldName: string) => (value: string) => {
  if (/^\d+$/.test(value)) {
    return { id: parseInt(value) };
  }

  return { [fieldName]: value };
};

const optionTextDefault = (option: GetB2bCompaniesOneResponse) => `(${option.id}) ${option.name}`;

export const B2bCompanySelectInput = ({
  source = 'company_id',
  reference = 'b2b/companies',
  referenceFilter,
  optionText = optionTextDefault,
  isRequired,
  validate,
  testId,
  ...props
}: B2bCompanySelectInputProps) => (
  <ReferenceInput
    source={source}
    reference={reference}
    isRequired={isRequired}
    data-testid={`${testId}_ReferenceInput`}
    filter={referenceFilter}>
    <AutocompleteInput
      optionText={optionText}
      filterToQuery={idOrFieldFilterToQuery('name')}
      isRequired={isRequired}
      validate={validate}
      {...props}
      data-testid={testId}
    />
  </ReferenceInput>
);
